import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentCancel() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/client/dashboard");
    }, 3000);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-red-600">Payment Cancelled 🎉</h1>
      <p>Redirecting to dashboard...</p>
    </div>
  );
}
